import React from 'react';
import { DRIVER_ORDER } from '@/data/clubDemoData';
import { SectionTitle, InsightBox, DriverCard } from './DemoShared';

export function Drivers({ club, dt }) {
  const d = dt.drivers;
  return (
    <section data-testid="section-drivers">
      <SectionTitle
        label={d.eyebrow}
        title={d.title}
        subtitle={d.subtitle}
      />
      <div className="grid sm:grid-cols-2 gap-4 mb-8">
        {DRIVER_ORDER.map((key) => (
          <DriverCard key={key} driverKey={key} value={club.drivers[key]} insight={club.driverInsights[key]} label={dt.driverLabels[key]} />
        ))}
      </div>
      <InsightBox variant="warning">
        {club.driverKeyInsight}
      </InsightBox>
    </section>
  );
}
